import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// react
import { useMemo } from 'react';
import styled from 'styled-components';
// components
import { Avatar, Card, Icon } from "../../atoms";
export const ConversationCard = ({ accountID, messages, createdAt, }) => {
    // memos
    const lastMessagePreview = useMemo(() => {
        if (!(messages === null || messages === void 0 ? void 0 : messages.length))
            return 'No messages yet';
        const lastMessage = messages[messages.length - 1];
        return lastMessage.content;
    }, [messages]);
    const participants = useMemo(() => {
        // get all participant names which are not the current user
        const participantNames = messages
            .filter((message) => message.accountId !== accountID)
            // deduplicate names
            .reduce((acc, message) => {
            if (!acc.includes(message.name)) {
                acc.push(message.name);
            }
            return acc;
        }, []);
        return participantNames.join(', ');
    }, [messages, accountID]);
    return (_jsxs(StyledCard, Object.assign({ color: 'blue', isBordered: false, isPaddingSm: true }, { children: [_jsx(Avatar, { fallback: (participants === null || participants === void 0 ? void 0 : participants[0]) || '', size: 'xs' }), _jsxs(LabelContainer, { children: [_jsx(StyledTitle, { children: participants }), _jsxs(ContentWrapper, { children: [_jsx(MessagePreview, { children: lastMessagePreview }), _jsx(Icon, { icon: 'circle', type: 'fas', fontSize: 3 }), _jsx(Timestamp, { children: createdAt })] })] })] })));
};
const StyledTitle = styled.div `
  font: ${(props) => props.theme.typography.body.sm.regular};
  color: ${(props) => props.theme.color.neutral[90]};
`;
const ContentWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[8]};
  flex: 1;

  font: ${(props) => props.theme.typography.body.sm.regular};
  color: ${(props) => props.theme.color.neutral[70]};
`;
const MessagePreview = styled.div `
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Timestamp = styled.div `
  text-align: right;
`;
const LabelContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const StyledCard = styled(Card) `
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[16]};
`;
ConversationCard.displayName = 'ConversationCard';
export default ConversationCard;
